import { useState } from "react";

const benefits = [
  "Dedicated placement support for your campus",
  "One platform for all hiring needs",
  "Active matching with verified architecture firms",
  "Structured internship pipelines, not one-off drives",
  "Placement reports you can show your management",
];

const timelineOptions = ["This batch", "Next semester", "Ongoing / rolling"];
const MOBILE_CODES = ["+91", "+1", "+44", "+61", "+971", "+65"];

const CheckIcon = () => (
  <svg viewBox="0 0 16 16" fill="none" className="partner-check-icon">
    <path
      d="M13 4L6 11.5L3 8.5"
      stroke="#c84b20"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const SuccessIcon = () => (
  <svg viewBox="0 0 24 24" fill="none">
    <path
      d="M20 6.5L9 17.5L4 12.5"
      stroke="#DD6B4D"
      strokeWidth="2.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const ChevronIcon = () => (
  <svg viewBox="0 0 16 16" fill="none" className="partner-chevron">
    <path
      d="M4 6L8 10L12 6"
      stroke="#6B645C"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const STYLES = `
  .partner-wrapper {
    min-height: 100vh;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #ECE8E1;
    padding: 40px 24px;
    font-family: 'Outfit', sans-serif;
    box-sizing: border-box;
  }
  .partner-wrapper * { box-sizing: border-box; }

  .partner-card {
    width: 100%;
    max-width: 1152px;
    display: flex;
    flex-direction: row;
    overflow: hidden;
    background: #fff;
  }
  @media (max-width: 767px) {
    .partner-wrapper { padding: 0; }
    .partner-card { flex-direction: column; max-width: 100%; }
  }

  .partner-aside {
    flex: 0 0 45%;
    background: #181110;
    color: #fff;
    padding: 48px 40px;
    display: flex;
    flex-direction: column;
  }
  @media (max-width: 767px) {
    .partner-aside { flex: 1 1 auto; padding: 40px 24px; }
  }

  .partner-badge {
    color: #c84b20;
    font-size: 12px;
    font-weight: 600;
    letter-spacing: 0.15em;
    text-transform: uppercase;
    margin: 0 0 16px;
  }

  .partner-heading-light {
    font-family: 'Playfair Display', Georgia, serif;
    font-weight: 300;
    color: #fff;
    font-size: clamp(28px, 4vw, 28px);
    line-height: 1.15;
    margin: 0 0 24px;
  }

  .partner-lead {
    color: #C9C2B8;
    font-size: 16px;
    line-height: 1.6;
    margin: 0 0 32px;
  }

  .partner-subtitle {
    color: #c84b20;
    font-weight: 600;
    font-size: 15px;
    margin: 0 0 16px;
  }

  .partner-list {
    list-style: none;
    margin: 0 0 8px;
    padding: 0;
    display: flex;
    flex-direction: column;
    gap: 15px;
  }

  .partner-list-item {
    display: flex;
    align-items: flex-start;
    gap: 12px;
    color: #EDE9E2;
    font-size: 15px;
  }
  .partner-check-icon {
    width: 16px;
    height: 16px;
    flex-shrink: 0;
    margin-top: 6px;
  }

  .partner-footer {
    margin-top: auto;
    padding-top: 32px;
    border-top: 1px solid rgba(255,255,255,0.1);
  }
  .partner-footer p { color: #B8B1A6; font-size: 14px; margin: 0; }

  .partner-main {
    flex: 1 1 auto;
    background: #fff;
    padding: 30px;
  }
  @media (max-width: 767px) {
    .partner-main { padding: 40px 24px; }
  }

  .partner-form-title {
    font-family: 'Playfair Display', Georgia, serif;
    font-weight: 400;
    line-height: 1.2;
    color: #1E1812;
    font-size: clamp(24px, 3vw, 28px);
    margin: 0 0 28px;
  }

  .partner-form {
    display: flex;
    flex-direction: column;
    gap: 24px;
  }

  .partner-section-label {
    font-weight: 400;
    font-size: 15px;
    color: #1E1812;
    margin: 0 0 12px;
    font-family: "Outfit", sans-serif;
  }

  .partner-row-2 {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 16px;
    margin-bottom: 16px;
  }
  @media (max-width: 640px) {
    .partner-row-2 { grid-template-columns: 1fr; }
  }
  .partner-row-2:last-child { margin-bottom: 0; }

  .partner-row-phone {
    display: flex;
    align-items: flex-start;
    gap: 16px;
  }
  .partner-code-wrap { width: 110px; flex-shrink: 0; position: relative; }
  .partner-number-wrap { flex: 1 1 auto; }

  .partner-field {
    width: 100%;
    background: #E9E4DA;
    padding: 10px 16px;
    font-size: 15px;
    color: #2B2620;
    border: 1px solid transparent;
    outline: none;
    font-family: inherit;
    transition: border-color 150ms, background-color 150ms;
  }
  .partner-field::placeholder { color: #8A8378; }
  .partner-field:focus { border-color: #c84b20; background: #F1EEE6; }
  .partner-field.partner-textarea { resize: none; }

  select.partner-field {
    appearance: none;
    -webkit-appearance: none;
    cursor: pointer;
    padding-right: 36px;
  }
  select.partner-field.partner-placeholder { color: #8A8378; }
  select.partner-field option { color: #2B2620; }

  .partner-select-wrap { position: relative; }
  .partner-chevron {
    width: 16px;
    height: 16px;
    position: absolute;
    right: 12px;
    top: 50%;
    transform: translateY(-50%);
    pointer-events: none;
  }

  .partner-submit {
    width: 100%;
    background: #1B140F;
    color: #fff;
    font-weight: 600;
    font-size: 15px;
    padding: 14px 0;
    border: none;
    cursor: pointer;
    transition: background-color 150ms;
  }
  .partner-submit:hover { background: #2A211A; }
  .partner-submit:active { background: #120D09; }
  .partner-submit:disabled { opacity: 0.65; cursor: not-allowed; }

  .partner-field.partner-invalid {
    border-color: #D64545;
    background: #FBEDEC;
  }
  .partner-error-msg {
    display: block;
    color: #D64545;
    font-size: 12.5px;
    margin-top: 6px;
    line-height: 1.4;
  }
  .partner-submit-error {
    color: #D64545;
    font-size: 14px;
    margin: -16px 0 0;
    text-align: center;
  }

  .partner-popup-overlay {
    position: fixed;
    inset: 0;
    background: rgba(24, 17, 16, 0.55);
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20px;
    z-index: 1000;
  }
  .partner-popup-card {
    background: #fff;
    max-width: 420px;
    width: 100%;
    padding: 40px 32px;
    text-align: center;
    box-shadow: 0 30px 80px -20px rgba(0,0,0,0.4);
  }
  .partner-popup-icon-wrap {
    width: 56px;
    height: 56px;
    margin: 0 auto 20px;
    border-radius: 50%;
    background: #FBEAE3;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .partner-popup-icon-wrap svg { width: 28px; height: 28px; }
  .partner-popup-title {
    font-family: 'Lora', Georgia, serif;
    font-weight: 600;
    color: #1E1812;
    font-size: 22px;
    margin: 0 0 10px;
  }
  .partner-popup-text {
    color: #6B645C;
    font-size: 14.5px;
    line-height: 1.6;
    margin: 0 0 28px;
  }
  .partner-popup-close {
    width: 100%;
    border-radius: 12px;
    background: #1B140F;
    color: #fff;
    font-weight: 600;
    font-size: 15px;
    padding: 14px 0;
    border: none;
    cursor: pointer;
  }
  .partner-popup-close:hover { background: #2A211A; }
`;

export default function PartnerCollegeSection() {
  const [form, setForm] = useState({
    collegeName: "",
    city: "",
    state: "",
    firstName: "",
    courseStream: "",
    hasPlacementCell: "",
    studentCount: "",
    timeline: "",
    designation: "",
    email: "",
    mobileCode: "+91",
    mobile: "",
    message: "",
  });

  const [errors, setErrors] = useState({});
  const [submitting, setSubmitting] = useState(false);
  const [submitError, setSubmitError] = useState("");
  const [showSuccess, setShowSuccess] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));

    if (errors[name]) {
      setErrors((prev) => {
        const next = { ...prev };
        delete next[name];
        return next;
      });
    }
  };

  const validate = (data) => {
    const newErrors = {};
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!data.collegeName.trim()) {
      newErrors.collegeName = "Please enter your college name.";
    }
    if (!data.city.trim()) {
      newErrors.city = "Please enter the city.";
    }
    if (!data.state.trim()) {
      newErrors.state = "Please enter the state.";
    }
    if (!data.firstName.trim()) {
      newErrors.firstName = "Please enter the contact person name.";
    }
    if (!data.courseStream.trim()) {
      newErrors.courseStream = "Please enter the course stream.";
    }
    if (!data.hasPlacementCell.trim()) {
      newErrors.hasPlacementCell = "Please select placement cell status.";
    }
    if (!data.studentCount.trim()) {
      newErrors.studentCount = "Please enter the student count.";
    }
    if (!data.timeline.trim()) {
      newErrors.timeline = "Please select the onboarding timeline.";
    }
    if (!data.designation.trim()) {
      newErrors.designation = "Please enter the designation.";
    }
    if (!data.email.trim()) {
      newErrors.email = "Please enter your email ID.";
    } else if (!emailRegex.test(data.email.trim())) {
      newErrors.email = "Please enter a valid email address.";
    }
    if (!data.mobile.trim()) {
      newErrors.mobile = "Please enter your mobile number.";
    } else if (!/^\d{7,12}$/.test(data.mobile.trim())) {
      newErrors.mobile = "Please enter a valid mobile number.";
    }

    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitError("");

    const validationErrors = validate(form);
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    setSubmitting(true);
    try {
      const payload = {
        collegeName: form.collegeName,
        city: form.city,
        state: form.state,
        firstName: form.firstName,
        designation: form.designation,
        email: form.email,
        mobileCode: form.mobileCode,
        mobile: form.mobile,
        partnershipType: "both",
        message: form.message,
        courseStream: form.courseStream,
        hasPlacementCell: form.hasPlacementCell,
        studentCount: form.studentCount,
        timeline: form.timeline,
      };

      const res = await fetch(`${process.env.REACT_APP_API_URL}/api/partnerYourCollege/`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      const data = await res.json();

      if (!res.ok) {
        throw new Error(data?.message || "Submission failed");
      }

      setForm({
        collegeName: "",
        city: "",
        state: "",
        firstName: "",
        courseStream: "",
        hasPlacementCell: "",
        studentCount: "",
        timeline: "",
        designation: "",
        email: "",
        mobileCode: "+91",
        mobile: "",
        message: "",
      });
      setErrors({});
      setShowSuccess(true);
    } catch (err) {
      console.error(err);
      setSubmitError("Something went wrong while submitting. Please try again.");
    } finally {
      setSubmitting(false);
    }
  };

  const fieldClass = (name) => `partner-field${errors[name] ? " partner-invalid" : ""}`;

  return (
    <div className="partner-wrapper">
      <style>{STYLES}</style>

      <div className="partner-card">
        <aside className="partner-aside">
          <div>
            <p className="partner-badge">Your Digital Placement Partner</p>
            <h1 className="partner-heading-light">
              Onboard your students. We'll get them hired.
            </h1>
            <p className="partner-lead">
              We work as an extended placement cell for architecture and design
              colleges — connecting your students directly with verified firms
              for internships, jobs, and real industry exposure.
            </p>

            <h2 className="partner-subtitle">What your college gets</h2>
            <ul className="partner-list">
              {benefits.map((item) => (
                <li key={item} className="partner-list-item">
                  <CheckIcon />
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </div>

          <div className="partner-footer">
            <p>500+ colleges already placing students through us</p>
          </div>
        </aside>

        <main className="partner-main">
          <p className="partner-badge">Start Collaboration</p>
          <h2 className="partner-form-title">Be Part of India's First Digital Placement Cell</h2>

          <form onSubmit={handleSubmit} className="partner-form">
            <section>
              <h3 className="partner-section-label">College Details</h3>

              <div className="partner-row-2">
                <div>
                  <input
                    type="text"
                    value={form.collegeName}
                    name="collegeName"
                    onChange={handleChange}
                    placeholder="College name *"
                    className={fieldClass("collegeName")}
                  />
                  {errors.collegeName && <span className="partner-error-msg">{errors.collegeName}</span>}
                </div>
                <div>
                  <input
                    type="text"
                    value={form.city}
                    name="city"
                    onChange={handleChange}
                    placeholder="City *"
                    className={fieldClass("city")}
                  />
                  {errors.city && <span className="partner-error-msg">{errors.city}</span>}
                </div>
              </div>

              <div className="partner-row-2">
                <div>
                  <input
                    type="text"
                    value={form.state}
                    name="state"
                    onChange={handleChange}
                    placeholder="State *"
                    className={fieldClass("state")}
                  />
                  {errors.state && <span className="partner-error-msg">{errors.state}</span>}
                </div>
                <div>
                  <input
                    type="text"
                    value={form.firstName}
                    name="firstName"
                    onChange={handleChange}
                    placeholder="Contact person name *"
                    className={fieldClass("firstName")}
                  />
                  {errors.firstName && <span className="partner-error-msg">{errors.firstName}</span>}
                </div>
              </div>

              <div className="partner-row-2">
                <div>
                  <input
                    type="text"
                    value={form.courseStream}
                    name="courseStream"
                    onChange={handleChange}
                    placeholder="Course / stream (e.g. Architecture) *"
                    className={fieldClass("courseStream")}
                  />
                  {errors.courseStream && <span className="partner-error-msg">{errors.courseStream}</span>}
                </div>
                <div>
                  <div className="partner-select-wrap">
                    <select
                      value={form.hasPlacementCell}
                      name="hasPlacementCell"
                      onChange={handleChange}
                      className={`${fieldClass("hasPlacementCell")}${form.hasPlacementCell ? "" : " partner-placeholder"}`}
                    >
                      <option value="" disabled>In-house placement cell? *</option>
                      <option value="yes">Yes</option>
                      <option value="partial">Partial / informal</option>
                      <option value="no">No</option>
                    </select>
                    <ChevronIcon />
                  </div>
                  {errors.hasPlacementCell && <span className="partner-error-msg">{errors.hasPlacementCell}</span>}
                </div>
              </div>
            </section>

            <section>
              <h3 className="partner-section-label">Onboarding Details</h3>

              <div className="partner-row-2">
                <div>
                  <input
                    type="number"
                    min="0"
                    value={form.studentCount}
                    name="studentCount"
                    onChange={handleChange}
                    placeholder="No. of students to onboard *"
                    className={fieldClass("studentCount")}
                  />
                  {errors.studentCount && <span className="partner-error-msg">{errors.studentCount}</span>}
                </div>
                <div>
                  <div className="partner-select-wrap">
                    <select
                      value={form.timeline}
                      name="timeline"
                      onChange={handleChange}
                      className={`${fieldClass("timeline")}${form.timeline ? "" : " partner-placeholder"}`}
                    >
                      <option value="" disabled>Preferred onboarding timeline *</option>
                      {timelineOptions.map((t) => (
                        <option key={t} value={t}>{t}</option>
                      ))}
                    </select>
                    <ChevronIcon />
                  </div>
                  {errors.timeline && <span className="partner-error-msg">{errors.timeline}</span>}
                </div>
              </div>
            </section>

            <section>
              <h3 className="partner-section-label">Contact Details</h3>

              <div className="partner-row-2">
                <div>
                  <input
                    type="text"
                    value={form.designation}
                    name="designation"
                    onChange={handleChange}
                    placeholder="Designation *"
                    className={fieldClass("designation")}
                  />
                  {errors.designation && <span className="partner-error-msg">{errors.designation}</span>}
                </div>
                <div>
                  <input
                    type="email"
                    value={form.email}
                    name="email"
                    onChange={handleChange}
                    placeholder="Email ID *"
                    className={fieldClass("email")}
                  />
                  {errors.email && <span className="partner-error-msg">{errors.email}</span>}
                </div>
              </div>

              <div className="partner-row-phone">
                <div className="partner-code-wrap">
                  <select
                    defaultValue="+91"
                    className="partner-field"
                    value={form.mobileCode}
                    name="mobileCode"
                    onChange={handleChange}
                  >
                    {MOBILE_CODES.map((c) => (
                      <option key={c} value={c}>{c}</option>
                    ))}
                  </select>
                  <ChevronIcon />
                </div>
                <div className="partner-number-wrap">
                  <input
                    type="tel"
                    value={form.mobile}
                    name="mobile"
                    onChange={handleChange}
                    placeholder="Mobile number *"
                    className={fieldClass("mobile")}
                  />
                  {errors.mobile && <span className="partner-error-msg">{errors.mobile}</span>}
                </div>
              </div>
            </section>

            <textarea
              rows={4}
              value={form.message}
              name="message"
              onChange={handleChange}
              placeholder="Message (optional)"
              className="partner-field partner-textarea"
            />

            {submitError && <p className="partner-submit-error">{submitError}</p>}

            <button type="submit" className="partner-submit" disabled={submitting}>
              {submitting ? "Submitting..." : "Start Collaboration"}
            </button>
          </form>
        </main>
      </div>

      {showSuccess && (
        <div className="partner-popup-overlay" onClick={() => setShowSuccess(false)}>
          <div className="partner-popup-card" onClick={(e) => e.stopPropagation()}>
            <div className="partner-popup-icon-wrap">
              <SuccessIcon />
            </div>
            <h3 className="partner-popup-title">Application Submitted!</h3>
            <p className="partner-popup-text">
              Thanks for partnering with IPDI. Our team will review your
              collaboration request and get back to you soon.
            </p>
            <button className="partner-popup-close" onClick={() => setShowSuccess(false)}>
              Done
            </button>
          </div>
        </div>
      )}
    </div>
  );
}